var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",class:{ 'my-12': !_vm.noMargin }},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":_vm.size,"width":_vm.width}},[(!_vm.noText)?_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t("formulaires.chargement")))]}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }